module.exports = __webpack_public_path__ + "static/images/styles/images/table/table-expand-shadow-top.5d40ac7b.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/table/table-expand-shadow-top.png
// module id = 3819
// module chunks = 11